import {AInesAssistantFeatureMapping, AInesAssistantType, AInesFeatureSet} from "@/graphql/generated/graphql";
import {query} from "@/graphql/client";
import {gql} from "@urql/vue";
import {getArrayUnique} from "@/helper/array";
import {useAppState} from "@/helper/appState";
import {kapitelErrorHandler} from "@/helper/error";

let mappingPromise : Promise<AInesAssistantFeatureMapping[]> | undefined;

const employeeAssistantFeatureMapping = [
    {
        "feature": AInesFeatureSet.Availability,
        "assistant": AInesAssistantType.Availability
    },
    {
        "feature": AInesFeatureSet.Sickness,
        "assistant": AInesAssistantType.Availability
    },
    {
        "feature": AInesFeatureSet.Vacation,
        "assistant": AInesAssistantType.Availability
    },
    {
        "feature": AInesFeatureSet.Timeoff,
        "assistant": AInesAssistantType.Availability
    },
    {
        "feature": AInesFeatureSet.Roster,
        "assistant": AInesAssistantType.Roster
    },
    {
        "feature": AInesFeatureSet.PlanningMonth,
        "assistant": AInesAssistantType.Planning
    },
    {
        "feature": AInesFeatureSet.JobsitePreferences,
        "assistant": AInesAssistantType.JobsitePreferences
    },
    {
        "feature": AInesFeatureSet.RegisterBooking,
        "assistant": AInesAssistantType.RegisterBooking
    },
    {
        "feature": AInesFeatureSet.Timesheet,
        "assistant": AInesAssistantType.Timesheet
    },
    {
        "feature": AInesFeatureSet.FeatureOverview,
        "assistant": AInesAssistantType.FeatureOverview
    },
    {
        "feature": AInesFeatureSet.DirectDemand,
        "assistant": AInesAssistantType.DirectDemand
    },
    {
        "feature": AInesFeatureSet.HumanRequest,
        "assistant": AInesAssistantType.FeatureOverview
    },
    {
        "feature": AInesFeatureSet.Kpi,
        "assistant": AInesAssistantType.KpiAndPayroll
    },
    {
        "feature": AInesFeatureSet.EmployeeDemandBrowser,
        "assistant": AInesAssistantType.EmployeeDemandBrowser
    },
]

const candidateAssistantFeatureMapping = [
    {
        "feature": AInesFeatureSet.JobsiteBrowser,
        "assistant": AInesAssistantType.CandidateAssistant
    },
    {
        "feature": AInesFeatureSet.InterestedIn,
        "assistant": AInesAssistantType.CandidateAssistant
    },
    {
        "feature": AInesFeatureSet.PromoteCandidate,
        "assistant": AInesAssistantType.CandidateAssistant
    },
    {
        "feature": AInesFeatureSet.DemandBrowser,
        "assistant": AInesAssistantType.CandidateAssistant
    },
    {
        "feature": AInesFeatureSet.WishDemand,
        "assistant": AInesAssistantType.CandidateAssistant
    }
]


const getAssistantFeatureMapping = ()=>{
    const role = useAppState().getEmployeeOrCandidate()
    switch(role){
        case "employee":
            return employeeAssistantFeatureMapping
        case "candidate":
            return candidateAssistantFeatureMapping
        default:
            kapitelErrorHandler("assistant feature mapping unknown for role " + role)
            return []
    }
}

export function resetAssistantFeatureMapping() {
    mappingPromise = undefined;
}

export async function getAvailableFeatureSets() : Promise<AInesFeatureSet[]> {
    const mapping = getAssistantFeatureMapping()
    return getArrayUnique(mapping.map(it => it.feature))
}

export async function getAvailableAssistants() : Promise<AInesAssistantType[]> {
    const mapping = getAssistantFeatureMapping()
    return getArrayUnique(mapping.map(it => it.assistant))
}

export async function getAssistentForFeatureSet( featureSet: AInesFeatureSet) : Promise<AInesAssistantType | undefined> {
    const mapping = getAssistantFeatureMapping()
    return mapping.find((it) => it.feature === featureSet)?.assistant
}

export async function getFeatureSetsForAssistant( assistant: AInesAssistantType) : Promise<AInesFeatureSet[]> {
    const mapping = getAssistantFeatureMapping()
    const result = mapping.filter((it) => it.assistant === assistant)
    if (result.length > 0) {
        return result.map(it => it.feature)
    }
    return []
}

export async function requireAssistentForFeatureSet( featureSet: AInesFeatureSet) : Promise<AInesAssistantType> {
    const assistant = await getAssistentForFeatureSet(featureSet)
    if (!assistant) {
        throw new Error('no assistant for ' + AInesFeatureSet[featureSet])
    }
    return assistant
}
